<template>
  <div class="container page">
    <van-nav-bar class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
      <template #title>
        <span style="font-size: 1rem; color: #fff;">{{ $t('setting.language') }}</span>
      </template>
    </van-nav-bar>
    <div class="items" id="content">
      <div
        class="item van-hairline--bottom"
        v-for="item in langs"
        :key="item.code"
        @click="changeLang(item.code, $event)"
      >
        <div class="flex_center">
          <div class="flag">{{ item.flag }}</div>
          <div class="info">{{ item.name }}</div>
        </div>
        <div v-if="lang == item.code">✓</div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import { Toast } from "vant";
import { LANGS, setLangManual } from "@/common/languages";

export default {
  name: "Language",
  data() {
    return {
      langs: LANGS,
      lang: this.$i18n.locale || "en_us",
      source: ''
    };
  },
  created() {},
  mounted() {
    this.source=this.$route.params.type
  },
  methods: {
    back(){
      return window.history.back();
    },
    changeLang(lang) {
      
      Toast.loading({
        // mask: true,
        duration: 200,
      });
      this.lang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      setLangManual();               // 手动选择优先，之后不再被 IP / 注册地区覆盖
      if (this.source=='setting'){
        this.$router.push({path:'/'});
      }else{
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.container .items {
  background-color: #fff;
  font-size: 30px;
  color: #000;
  padding: 0 25px;
}
.container .items .item {
  padding: 10px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
}
.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
}
.container .sign-out {
  margin: 500px 20px 0;
  height: 100px;
  line-height: 100px;
  border-radius: 50px;
  color: #fff;
  font-size: 40px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(270deg, #e6c3a1, #7e5678);
}
.container .item .desc {
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}
.container .item .right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.flex_center {
  display: flex;
  align-items: center;
}
.flex_center .flag {
  width: 60px;
  height: 60px;
  line-height: 60px;
  font-size: 44px;
  margin-right: 20px;
}
</style>
